module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZBAMAAADd8CNTAAAAMFBMVEUAAACMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5kkTwceAAAAD3RSTlMA6UmOxVI60Jl+dCrXph1+lJOdAAAAYklEQVQY02Nglv8PAx8NGOz/I8BnBvkEBhhg+8jwnwEB/lONxySoAEFgHuN/AQhC5aGrpIlb5APgHNaPDOvBYfCnj9v///9fDJzQUGoBhtIEqCLu+/8LkAxg8xdgQAKsIDkAjJNYjfTpaRIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/i_comment.png
// module id = 782
// module chunks = 4